import { useMutation } from 'react-query';

import { putTrapNewLocation as putTrapNewLocationApi } from './../../api/InteractiveMap/putTrapNewLocation';

const usePutTrapNewLocation = () => {
  const { isSuccess, mutate: putTrapNewLocation, isLoading } = useMutation(putTrapNewLocationApi);

  return {
    isSuccess,
    putTrapNewLocation,
    isLoading,
  };
};

export default usePutTrapNewLocation;
